/**
 * 주소 검색 컴포넌트
 * 
 * 주요 기능:
 * 1. 다음 우편번호 서비스 통합
 * 2. 주소 검색 및 선택
 * 3. 선택된 주소 정보 상태 업데이트
 * 
 * 데이터 처리:
 * - 다음 우편번호 API 사용
 * - 도로명 주소 및 지번 주소 처리
 * 
 * 상태 관리:
 * - searchParamState: 검색된 주소 정보 업데이트
 * 
 * UI 요소:
 * - 검색 버튼
 * - 선택된 주소 표시
 * - 주소 초기화 버튼
 * 
 * 주의사항:
 * - 다음 우편번호 API 스크립트 동적 로드
 * - 컴포넌트 언마운트 시 스크립트 정리
 */
import React, { useEffect, useState } from "react";
import { UseFormRegister } from "react-hook-form";
import { useSafeState } from "react-query/types/devtools/utils";
import { useRecoilState } from "recoil";
import { mapParamState, searchParamState } from "../../atoms";
import { cls } from "../../util/cls";
const SearchPlace = ({ register }: { register: UseFormRegister<any> }) => {
  const [, setSearchParam] = useRecoilState(searchParamState);
  const [param, setParam] = useRecoilState(mapParamState);
  const [address, setAddress] = useState("");
  const [position, setPosition] = useState<{
    lat: number;
    lng: number;
  }>({
    lat: 0,
    lng: 0,
  });
  function execDaumPostcode() {
    new window.daum.Postcode({
      oncomplete: function (data) {
        // 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.

        // 도로명 주소의 노출 규칙에 따라 주소를 표시한다.
        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
        var roadAddr = data.roadAddress; // 도로명 주소 변수
        var extraRoadAddr = ""; // 참고 항목 변수

        // 법정동명이 있을 경우 추가한다. (법정리는 제외)
        // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
        if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
          extraRoadAddr += data.bname;
        }
        // 건물명이 있고, 공동주택일 경우 추가한다.
        if (data.buildingName !== "" && data.apartment === "Y") {
          extraRoadAddr +=
            extraRoadAddr !== "" ? ", " + data.buildingName : data.buildingName;
        }
        // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
        if (extraRoadAddr !== "") {
          extraRoadAddr = " (" + extraRoadAddr + ")";
        }

        if (roadAddr !== "") {
          const addr = `${roadAddr} ${extraRoadAddr}`;
          setAddress(addr);
          setSearchParam((prev) => ({ ...prev, place: addr }));
        } else {
          const addr = `${roadAddr}`;
          setAddress(addr);
        }
      },
    }).open();
  }
  return (
    <div className="flex w-full  border border-silver rounded-lg py-2 pl-[20px] pr-[16px] ">
      <button
        className={cls(
          "w-full textfield appearance-none focus:outline-none cursor-pointer text-left",
          address ? "text-[min(4vw,0.9rem)]" : "text-gray-400",
        )}
        onClick={() => execDaumPostcode()}
        {...register("place")}
      >
        {address ? address : "장소를 입력해주세요"}
      </button>
      {address && (
        <button
          className="ml-3"
          onClick={() => {
            setAddress("");
            setSearchParam((prev) => ({ ...prev, place: "" }));
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="size-6 text-gray-500"
          >
            <path
              fillRule="evenodd"
              d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default SearchPlace;
